/**
 * Traditionally, the root reducer file is named index.js
 *
 * This rootReducer config object is passed to Redux.createStore() in
 * configurestore.{env}.js.
 */
import {combineReducers} from 'redux';
import errorReducer from './errorreducer';
import {
	engagementReducer,
	engagementsSummaryReducer,
	engagementReducerAllUserEngagements,
	engagementMetaDataReducer,
	engagementUsersWithRoles,
	countryStatusReducer,
	engagementUserRolesReducer,
	rbacUserRolesReducer
} from './Engagements/engagementreducer';
import configurationsReducer from './Configurations/configurationsreducer';
import paansReducer from './Paans/paansreducer';
import {quickLinkReducer} from './Engagements/quicklinksreducer';
import appOnlineStateReducer from './apponlinestatereducer';
import connectivityStateReducer from './connectivitystatereducer';
import offlinePrepReducer from './offlineprepreducer';
import orgChartReducer from './Project/OrgChart';
import userPreferencesReducer from './userpreferences/userpreferencesreducer';
import documentReducer from './Document/documentsreducer';
import VersionUpgradeStateReducer from './versionreducer';
import sampleReducer from './Sample/sampleReducer';
import getAllProjectsReducer from './Project/getallprojectsreducer';
import getAllOtherProjectsReducer from './Project/getallotherprojectsreducer';
import projectDetailsReducer from './Project/projectdetailsreducer';
import getAllClientsReducer from './Clients/clientreducer';
import timezoneReducer from './userpreferences/timezonesreducer';
import createProjectReducer from './Project/projectcreatereducer';
import EngagementMetricsReducer from './Metrics/engagementMetricsReducer';
import usersearchreducer from './UserSearch/usersearchreducer';
import {accessGroupReducer, projectTeamReducer} from './AccessGroups/accessgroupreducer';
import dashboardContextReducer from './Metrics/dashboardContextReducer';
import dashboardFiltersReducer from './Metrics/dashboardFiltersReducer';
import modalopenstatereducer from './AccessGroups/modalopenstatereducer';
import engagementUserReducer from './EngagementUser/engagmentUserReducer';
import EditModeReducer from './Project/editmodereducer';
import RollForwardModeReducer from './Project/rollforwardmodereducer';
import GroupEditModeReducer from './AccessGroups/groupeditmodereducer';
import MultiSelectModeReducer from './AccessGroups/multiselectusermodereducer';
import OversightActiveTabReducer from './Project/oversightactivetabreducer';
import DashboardPermissionsReducer from './Project/dashboardpermissionsreducer';
import QuickFiltersReducer from './Project/quickFiltersReducer';
import ProjectEngagementUserReducer from './Project/projectengagementsuserreducer';
import DelegateActiveTabReducer from '../reducers/Delegate/delegateactivetabreducer';
import delegateReducer from '../reducers/Delegate/delegateReducer';
import {timeoutReducer} from './timeoutReducer';
import {isInternalReducer} from './isInternalReducer';
import {userContextReducer} from './usercontextReducer';
import {isSignInReducer} from './isSignInReducer';
import getAdminUserReducer from './AdminUser/adminuserreducer';
import getAdminUsersReducer from './AdminUser/adminusersreducer';
import getAdminUserClientReducer from './AdminUser/adminuserclientreducer';
import getAdminUserProjectReducer from './AdminUser/adminuserprojectreducer';
import AdminUserActiveTabReducer from './AdminUser/adminuseractivetabreducer';
import getAdminUserOtherProjectReducer from './AdminUser/adminuserotherprojectreducer';
import modalOpenUnsavedUserDataReducer from './AdminUser/modalopenunsaveduserdatareducer';
import commonWarningModalReducer from './AdminUser/ProjectReducers/commonwarningmodalreducer';
import {contactDBReducer} from './ContactDB';
import {userMSData} from './UserMSData';
import {contactDBAccessLog} from './ContactDBAccessLog';
import filterdatareducer from './Filter/filterdatareducer';
import ContactDBFilterReducer from './ContactDB/ContactDBFilterReducer';
import {countriesReducer} from './Countries';

import {messageLogReducer} from './MessageLog';
import entityAdminsKeyContactsReducer from './entityadminskeycontactsreducer';
import {activityLogReducer} from './ActivityLog';
import {reconciliationsReducer} from './Reconciliations';
import getClientRequestReducer from './ClientPortalMetrics/clientrequestreducer';
import getRisksReducer from './GroupRiskAsssesment/risksReducer';
import {adobeAnalytics} from '@ey/voltron-analytics';

const rootReducer = combineReducers({
	activityLog: activityLogReducer,
	apponlinestate: appOnlineStateReducer,
	allUserEngagements: engagementReducerAllUserEngagements,
	appVersion: VersionUpgradeStateReducer,

	clientRequest: getClientRequestReducer,

	risks: getRisksReducer,

	sessionTimer: timeoutReducer,
	isInternal: isInternalReducer,
	userContext: userContextReducer,

	configurations: configurationsReducer,

	paansuserdata: paansReducer,

	countryStatus: countryStatusReducer,
	connectivitystate: connectivityStateReducer,

	contacts: contactDBReducer,
	filterData: filterdatareducer,
	contactDBFilters: ContactDBFilterReducer,
	contactsAccessLog: contactDBAccessLog,
	usersMSData: userMSData,

	countries: countriesReducer,

	dashboardContext: dashboardContextReducer,
	dashboardFilters: dashboardFiltersReducer,

	documents: documentReducer,

	errors: errorReducer,
	engagement: engagementReducer,
	engagementsSummary: engagementsSummaryReducer,
	engagementReducerAllUserEngagements: engagementReducerAllUserEngagements,
	engagementMetrics: EngagementMetricsReducer,
	engagementMetaData: engagementMetaDataReducer,
	engagementUsersWithRoles: engagementUsersWithRoles,
	engagementUser: engagementUserReducer,

	messageLog: messageLogReducer,

	offlinePrep: offlinePrepReducer,

	orgChart: orgChartReducer,

	quickFilters: QuickFiltersReducer,
	quickLink: quickLinkReducer,

	reconciliations: reconciliationsReducer,

	roles: engagementUserRolesReducer,
	rbacRoles: rbacUserRolesReducer,

	userPreferences: userPreferencesReducer,

	sample: sampleReducer,

	project: projectDetailsReducer,
	allProjects: getAllProjectsReducer,
	allOtherProjects: getAllOtherProjectsReducer,
	newProject: createProjectReducer,
	allClients: getAllClientsReducer,
	timezones: timezoneReducer,
	userSearchResults: usersearchreducer,

	accessGroups: accessGroupReducer,
	projectTeam: projectTeamReducer,
	isModalOpen: modalopenstatereducer,
	isEditMode: EditModeReducer,
	isRollForwardMode: RollForwardModeReducer,
	isGroupEditMode: GroupEditModeReducer,
	isMultiSelectMode: MultiSelectModeReducer,
	oversightActiveTab: OversightActiveTabReducer,
	permissions: DashboardPermissionsReducer,
	projectEngagementsUsers: ProjectEngagementUserReducer,
	delegate: delegateReducer,
	delegateActiveTab: DelegateActiveTabReducer,
	isSignIn: isSignInReducer,
	adminUser: getAdminUserReducer,
	adminUsers: getAdminUsersReducer,
	adminUserClient: getAdminUserClientReducer,
	adminUserProject: getAdminUserProjectReducer,
	adminUserOtherProject: getAdminUserOtherProjectReducer,
	adminUserActiveTab: AdminUserActiveTabReducer,
	isUnsavedUserDataModalOpen: modalOpenUnsavedUserDataReducer,
	unsavedData: commonWarningModalReducer,
	entityAdminsKeyContacts: entityAdminsKeyContactsReducer,
	adobeAnalytics: adobeAnalytics.adobeAnalyticsReducer
});

export default rootReducer;
